import {
  getMasonryWSAsyncNodeData,
  type MasonryWSGetterParams,
} from '@leagueplatform/masonry-api';
import {
  createMasonryEngineActionController,
  type MasonryEngineDriver,
} from '@leagueplatform/masonry-engine';
import {
  MasonryWSDriverNodeRenderersRegistry,
  type MasonryWSDriverRegistryNode,
} from './masonry-WS-driver-node-renderers-registry';

// Passing an empty action handler map for Masonry WS driver, as this driver
// works independent of action controller.
export const MasonryWSDriverActionController =
  createMasonryEngineActionController({});

export const wsDriver: MasonryEngineDriver<
  MasonryWSDriverRegistryNode,
  any,
  MasonryWSGetterParams
> = {
  nodeRendererRegistry: MasonryWSDriverNodeRenderersRegistry,
  actionController: MasonryWSDriverActionController,
  getAsyncNodeData: getMasonryWSAsyncNodeData,
};
